import React, { useMemo } from 'react';
import { Box } from '@tapresearch/ui/components';
import { ResponsiveBump } from '@nivo/bump';
import { formatBumpChartData } from './formatBumpChartData';
import { useColorScheme } from './useColorScheme';
export function ResponsiveBumpChart(param) {
    var data = param.data;
    var formattedData = useMemo(function() {
        return formatBumpChartData(data);
    }, [
        data
    ]);
    var chartColors = useColorScheme();
    return /*#__PURE__*/ React.createElement(Box, {
        height: "400px"
    }, /*#__PURE__*/ React.createElement(ResponsiveBump, {
        data: formattedData,
        colors: chartColors,
        lineWidth: 3,
        activeLineWidth: 6,
        inactiveLineWidth: 3,
        inactiveOpacity: 0.15,
        pointSize: 10,
        activePointSize: 16,
        inactivePointSize: 0,
        pointColor: {
            theme: 'background'
        },
        pointBorderWidth: 3,
        activePointBorderWidth: 3,
        pointBorderColor: {
            from: 'serie.color'
        },
        axisBottom: {
            tickSize: 5,
            tickPadding: 5,
            tickRotation: 0,
            legend: '',
            legendPosition: 'middle',
            legendOffset: 32
        },
        axisLeft: {
            tickSize: 5,
            tickPadding: 5,
            tickRotation: 0,
            legend: 'Rank Order',
            legendPosition: 'middle',
            legendOffset: -50
        },
        margin: {
            top: 40,
            right: 150,
            bottom: 40,
            left: 80
        }
    }));
}
